export default {
  path: 'validate',
  meta: {
    requiresAuth: true,
    requiresRoAccess: true
  },
  component: () => import('./ValidateTab')
}
